import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Dropdown, Menu, notification, Input, Tag } from "antd";
import { RxDotsHorizontal } from "react-icons/rx";
import { groupedContent, tableCustomStyles } from "../../../helperFuncs";
import {
  useDeleteSegmentMutation,
  useGetCustomersByAliasMutation,
} from "../../../services/segmentation.services";
import ConfirmationModal from "../../Settings/Modals/ConfirmationModal";
import { useSelector } from "react-redux";
import CommandModal from "../../Meter/modals/CommandModal";
import ScheduleConnection from "../../Commands/Modals/ScheduleConnection";
import ScheduleDisconnection from "../../Commands/Modals/ScheduleDisconnection";
import LooperTimer from "../../Commands/Modals/LoopTimer";
import TriggerResult from "../../Commands/Modals/TriggerResult";
import TONModal from "../../Commands/Modals/TONModal";
import OFFModal from "../../Commands/Modals/OFFModal";

const CustomerSegmentTable = ({ segmentData, refresh }) => {
  const [selectedSegment, setSelectedSegment] = useState("");
  const [selectedcommand, setselectedcommand] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [commandmodal, setcommandmodal] = useState(false);
  const { siteid } = useSelector((state) => state.projectSite);
  const [openDrawer, setOpenDrawer] = useState(null);
  const [result, setresult] = useState(null);
  const [openresult, setopenresult] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  let intialCommand = {
    CON: false,
    DIS: false,
    LUP: false,
    TON: false,
    OFF: false,
  };
  const [command, setcommand] = useState(intialCommand);

  // Initialize filtered data when component mounts or when segmentData changes
  useEffect(() => {
    setFilteredData(segmentData || []);
  }, [segmentData]);

  const [
    getCustomersByAlias,
    { isLoading: segmentloadin, data: segmentdata, error: segmenterror },
  ] = useGetCustomersByAliasMutation();

  const handleSegment = (alias) => {
    getCustomersByAlias({ alias, siteid })
      .then((res) => {
        if (res.error) {
          console.log(res.error, "error");
        } else {
          console.log(res.data, "data");
        }
      })
      .catch((err) => {});
  };

  const [deleteSegment, { isLoading }] = useDeleteSegmentMutation();
  const handleContinue = () => {
    deleteSegment({ alias: selectedSegment, siteid })
      .then((res) => {
        if (res.error) {
          notification.error({
            message: "Failed",
            description: "Failed to delete segment",
          });
        } else {
          notification.success({
            message: "Success",
            description: "Segment deleted successfully",
          });
          setConfirmation(false);
          refresh((prev) => !prev);
        }
      })
      .catch((err) => {
        console.log(err, "Error in catch block");
      });
  };

  // Columns configuration for the table
  const columns = [
    {
      name: "Alias",
      selector: (row) => row.alias,
      center: true,
      grow: 1,
    },
    {
      name: "Filters Used",
      grow: 4,
      selector: (row) => row.filters,
      center: true,
      cell: (row) => (
        <div className="flex flex-wrap gap-1">
          {row.filters
            ? Object.entries(row.filters)
                .filter(([key, value]) => value !== null)
                .map(([key, value], index) => (
                  <Tag key={index} color="orange">
                    {key}: {value}
                  </Tag>
                ))
            : ""}
        </div>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.description,
      center: true,
    },
    {
      name: "Action",
      grow: 1,
      center: true,
      cell: (row) => {
        // Dropdown menu for the "Action" column
        const dropdownMenu = (
          <Menu className="w-[200px]">
            {/* <Menu.Item
              key="details"
              onClick={() => {
                handleSegment(row?.alias);
              }}
            >
              Details
            </Menu.Item> */}
            <Menu.Item
              key="commands"
              onClick={() => {
                setSelectedSegment(row?.alias);
                setcommandmodal(true);
              }}
            >
              Trigger command
            </Menu.Item>
            <Menu.Item
              key="delete"
              className="text-red-400 flex items-center justify-center"
              onClick={() => {
                setSelectedSegment(row?.alias); // Set the selected segment alias
                setConfirmation(true); // Open the confirmation modal
              }}
            >
              Delete
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown overlay={dropdownMenu} trigger={["hover"]}>
            <div className="cursor-pointer">
              <RxDotsHorizontal />
            </div>
          </Dropdown>
        );
      },
    },
  ];

  const handleCommandType = () => {
    setselectedcommand(selectedcommand);
  };

  return (
    <>
      <TriggerResult
        response={result}
        setOpen={setopenresult}
        open={openresult}
      />

      <TONModal
        setresult={setresult}
        setopenresult={setopenresult}
        open={command.TON}
        intialCommand={intialCommand}
        setcommand={setcommand}
        alias={selectedSegment}
        setOpen={() =>
          setcommand((prev) => {
            return {
              ...prev,
              TON: false,
            };
          })
        }
      />

      <OFFModal
        setresult={setresult}
        setopenresult={setopenresult}
        open={command.OFF}
        intialCommand={intialCommand}
        setcommand={setcommand}
        alias={selectedSegment}
        setOpen={() =>
          setcommand((prev) => {
            return {
              ...prev,
              OFF: false,
            };
          })
        }
      />
      <LooperTimer
        setresult={setresult}
        setopenresult={setopenresult}
        open={command.LUP}
        intialCommand={intialCommand}
        setcommand={setcommand}
        alias={selectedSegment}
        setOpen={() =>
          setcommand((prev) => {
            return {
              ...prev,
              LUP: false,
            };
          })
        }
        title={"this is the title"}
      />
      <ScheduleConnection
        type="alias"
        open={command.CON}
        setresult={setresult}
        setopenresult={setopenresult}
        alias={selectedSegment}
        intialCommand={intialCommand}
        setcommand={setcommand}
        setOpen={() =>
          setcommand((prev) => {
            return {
              ...prev,
              CON: false,
            };
          })
        }
        title={"this is the title"}
      />
      <ScheduleDisconnection
        setresult={setresult}
        setopenresult={setopenresult}
        open={command.DIS}
        alias={selectedSegment}
        intialCommand={intialCommand}
        setcommand={setcommand}
        setOpen={() =>
          setcommand((prev) => {
            return {
              ...prev,
              DIS: false,
            };
          })
        }
        title={"this is the title"}
      />
      <CommandModal
        command={command}
        setcommand={setcommand}
        selectedcommand={selectedcommand}
        setselectedcommand={setselectedcommand}
        groupedContent={groupedContent}
        isVisible={commandmodal}
        onClose={() => setcommandmodal(false)}
      />
      {confirmation && (
        <ConfirmationModal
          title={"Delete Segmentation"}
          handleContinue={handleContinue}
          description={`Are you sure you want to delete (${selectedSegment})?
            The segment will no longer be available for usage.
            Type <span class="bg-gray-100 rounded-md px-[4px]">I understand</span> to continue.`}
          isModalOpen={confirmation}
          loading={isLoading}
          setIsModalOpen={setConfirmation}
          btntext={"Remove segment"}
        />
      )}
      {/* {openDrawer}  */}
      <DataTable
        columns={columns}
        data={segmentData ?? []}
        pagination
        customStyles={tableCustomStyles}
      />
    </>
  );
};

export default CustomerSegmentTable;
